<template>
  <VCharts
    v-if="renderChart"
    :option="option"
    :autoresize="autoResize"
    :init-options="echartsInitOptions"
    :style="{ width, height }"
  />
</template>

<script lang="ts" setup>
  import { ref, nextTick } from 'vue';
  import VCharts from 'vue-echarts';

  defineProps({
    option: {
      type: Object,
      default() {
        return {};
      },
    },
    autoResize: {
      type: Boolean,
      default: true,
    },
    width: {
      type: String,
      default: '100%',
    },
    height: {
      type: String,
      default: '100%',
    },
  });

  /** 避免移动端 canvas 发糊（默认 DPR 在部分环境下偏低） */
  const echartsInitOptions = {
    devicePixelRatio:
      typeof window !== 'undefined'
        ? Math.min(Math.max(window.devicePixelRatio || 1, 1), 3)
        : 2,
  };

  const renderChart = ref(false);
  nextTick(() => {
    renderChart.value = true;
  });
</script>

<style scoped lang="less"></style>
